export const buildCircuitSavePayload = (
  allCircuits,
  updatedCircuits,
  formData,
  diversityGroups,
  structureId,
) => {
  if (!Array.isArray(updatedCircuits)) return [];

  const resolve = (list, value, key = "name") => {
    if (!value || !Array.isArray(list)) return null;
    const firstItem = list[0];

    if (typeof firstItem === "string") {
      return list.includes(value) ? value : null;
    }

    const found = list.find((i) => i[key] === value);
    return found ? { ...found } : null;
  };

  return updatedCircuits.map(({ circuitId, fields }) => {
    const originalCircuit = allCircuits.find(
      (c) => c.circuitGmId === Number(circuitId),
    );

    const isNew = !originalCircuit;

    const merged = {
      ...(originalCircuit ?? {}),
      ...fields,
    };

    const circuitDiversityGroups = isNew
      ? []
      : (diversityGroups
          ?.filter((group) =>
            group?.circuits?.some(
              (c) => c?.circuitGmId === originalCircuit.circuitGmId,
            ),
          )
          .map((g) => ({ id: g.id })) ?? []);

    return {
      circuitGmId: isNew ? null : originalCircuit.circuitGmId,
      structureId,

      circuitVendorId: merged.circuitVendorId,
      status: resolve(formData.status, merged.status),
      use: resolve(formData.use, merged.use),
      type: resolve(formData.type, merged.type),
      category: resolve(formData.category, merged.category),

      carrier: resolve(formData.carrier, merged.carrier, "carrierName"),
      lec: resolve(formData.carrier, merged.lec, "carrierName"),

      handoffType: resolve(formData.handoffType, merged.handoffType),
      redundancyType: resolve(formData.redundancyType, merged.redundancyType),
      scope: resolve(formData.scope, merged.scope),

      mrcBaseline: merged.mrcBaseline,
      portBandwidth: merged.portBandwidth,
      accessBandwidth: merged.accessBandwidth,
      vcBandwidth: merged.vcBandwidth,

      currency: resolve(formData.iosCurrency, merged.currency),
      billToCountry: resolve(formData.countries, merged.billToCountry),

      cutoverDate: merged.cutoverDate,
      forecastDeliveryDate: merged.forecastDeliveryDate,
      actualHandoverDate: merged.actualHandoverDate,
      currentTermEndDate: merged.currentTermEndDate,
      actualBillingStartDate: merged.actualBillingStartDate,
      actualBillingStopDate: merged.actualBillingStopDate,
      requestedDisconnectDate: merged.requestedDisconnectDate,

      diversePop: merged.diversePop,
      diversePhysicalPath: merged.diversePhysicalPath,

      circuitNote: originalCircuit?.circuitNote ?? "",

      diversityGroups: circuitDiversityGroups,
    };
  });
};
